<template>
  <div class="container">
    <div class="loading"></div>
  </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>
  .container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    background-color: rgba(55,55,55,.3);
  }

  .loading {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    border: 5px rgba(0, 0, 0, 0.1) solid;
    /*border-right-color: #87CEEB;*/
    border-right-color: #007bff;
    animation: loading 1s linear infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
